import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}
  handleError(error: any): void {
    this.injector.get<AppInsightsService>(AppInsightsService).logException(error);
    console.log(error);
  }
}
